import React, { useState } from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

interface MobileSliderProps {
  children: React.ReactNode;
  dotColor?: string;
}

const MobileSlider: React.FC< MobileSliderProps> = ({ children,
  dotColor = "#ffffff",
 }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);

  // Autoplay plugin
  const autoplay = (slider: any) => {
    let timeout: ReturnType<typeof setTimeout>;
    let mouseOver = false;

    const clearNextTimeout = () => {
      clearTimeout(timeout);
    }
    const nextTimeout = () => {
      clearTimeout(timeout);
      if (mouseOver) return;
      timeout = setTimeout(() => {
        slider.next();
      }, 3000);
    }

    slider.on("created", () => {
      slider.container.addEventListener("mouseover", () => {
        mouseOver = true;
        clearNextTimeout();
      });
      slider.container.addEventListener("mouseout", () => {
        mouseOver = false;
        nextTimeout();
      });
      nextTimeout();
    });
    slider.on("dragStarted", clearNextTimeout);
    slider.on("animationEnded", nextTimeout);
    slider.on("updated", nextTimeout);
  };

  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>(
    {
      initial: 0,
      loop: true,
      slides: {
        perView: 1,
        spacing: 0, // 👈 ensures full width
      },
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
    },
    [autoplay],
  );

  return (
    <div className="container mx-auto container-p-0">
      <div ref={sliderRef} className="keen-slider">
        {React.Children.map(children, (child, idx) => (
          <div className="keen-slider__slide w-full" key={idx}>
            {child}
          </div>
        ))}
      </div>

      {/* Dots */}
      {loaded && instanceRef.current && (
        <div className="flex justify-center items-center gap-2 px-[24px] pt-[32px] py-[24px] bg-transparent mt-[0] max-w-[244px] mx-auto">
          {Array.from({
            length: instanceRef.current.track.details.slides.filter(
              (s: any) => !s.clone,
            ).length,
          }).map((_, idx) => (
            <button
              aria-label="dot"
              key={idx}
              onClick={() => instanceRef.current?.moveToIdx(idx)}
              className={`p-0 relative overflow-hidden ${
                currentSlide === idx
                  ? "flex-1 min-w-[60px] w-16 h-1"
                  : "flex-none w-4 h-1"
              }`}
              style={{ backgroundColor: dotColor }}
            >
              <span
                className={`absolute top-0 left-0 w-full h-1 ${
                  currentSlide === idx
                    ? "bg-gradient-to-r from-[#8ABC00] to-[#0086E6] transition-all duration-[2000ms] delay-[200ms]"
                    : "left-[-100%]"
                }`}
              ></span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
export default MobileSlider;